import QRCode from 'qrcode.react';
import Model3D from '@/components/Model3D';
import { useEffect, useState } from 'react';
import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { getWebViewPlatform } from '@/utils/JSBridge';
const isIOS = getWebViewPlatform() === 'iOS';
export default function L() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('PowerOcean.L');
    const { locale } = useRouter();

    const [active, setActive] = useState(0);
    const [qrcodeUrl, setQRCodeUrl] = useState('');
    const [isIOSA, setIsIOSA] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setQRCodeUrl(`${window?.origin}/${locale}/ar?glb=/models/power-ocean/s1.glb&redirect=/${locale}/products/powerocean`);
        }
        setIsIOSA(isIOS);
    }, []);
    return (
        <div className={`power-ocean-home-L ${styles['power-ocean-home-L']}`}>
            <div className="pc">
                <h2 className="title">{t('title')}</h2>
                <div className="tabs">
                    <span className={`tab tab-3d ${active === 0 ? 'active' : ''}`} onClick={() => setActive(0)}>
                        {t('3D')}
                    </span>
                    <span className={`tab tab-ar ${active === 1 ? 'active' : ''}`} onClick={() => setActive(1)}>
                        {t('AR')}
                    </span>
                </div>
                <div className="content-box">
                    <div className={`box-3d ${active === 0 ? 'show' : 'hide'}`}>
                        <div className="text-box">
                            <p className="text-title">{t('3D-title')}</p>
                            <ul className="text-content">
                                <li className="text">{t('item1')}</li>
                                <li className="text">{t('item2')}</li>
                                <li className="text">{t('item3')}</li>
                            </ul>
                        </div>
                        <div className="modal-3d">
                            <Model3D
                                props={{
                                    style: { width: '440px', height: '400px', margin: '0 auto' },
                                    src: 'https://websiteoss.ecoflow.com/upload/image/1768980860065/s1.glb',
                                }}
                            />
                        </div>
                    </div>
                    <div className={`box-ar ${active === 1 ? 'show' : 'hide'}`}>
                        <div className="text-box">
                            <div className="qr-code">
                                <QRCode value={qrcodeUrl} renderAs="canvas" style={{ width: '90px', height: '90px', position: 'relative' }} />
                            </div>
                            <p className="text-title">{t('AR-title')}</p>
                            <p className="text-desc">{t('AR-desc')}</p>
                            <ul className="text-content">
                                <li className="text">{t('item1')}</li>
                                <li className="text">{t('item2')}</li>
                                <li className="text">{t('item3')}</li>
                            </ul>
                        </div>
                        <div className="img-box">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1768980906457/12.png" alt={t`Use AR to fit PowerOcean in your house`} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="h5">
                <h2 className="title">{t('title')}</h2>
                <div className="tabs">
                    <span className={`tab tab-3d ${active === 0 ? 'active' : ''}`} onClick={() => setActive(0)}>
                        {t('3D')}
                    </span>
                    <span className={`tab tab-ar ${active === 1 ? 'active' : ''}`} onClick={() => setActive(1)}>
                        {t('AR')}
                    </span>
                </div>
                <div className="content-box">
                    <div className={`box-3d ${active === 0 ? 'show' : 'hide'}`}>
                        <div className="text-box">
                            <p className="text-title">{t('3D-title')}</p>
                            <ul className="text-content">
                                <li className="text">{t('item1')}</li>
                                <li className="text">{t('item2')}</li>
                                <li className="text">{t('item3')}</li>
                            </ul>
                        </div>
                        <div className="modal-3d">
                            <Model3D
                                props={{
                                    style: { width: '2.7rem', height: '2.7rem', margin: '0 auto' },
                                    src: 'https://websiteoss.ecoflow.com/upload/image/1768980860065/s1.glb',
                                }}
                            />
                        </div>
                    </div>
                    <div className={`box-ar ${active === 1 ? 'show' : 'hide'}`}>
                        <div className="text-box">
                            <p className="text-title">{t('AR-title')}</p>
                            {isIOSA && (
                                <a className="link" href={qrcodeUrl}>
                                    {t('open')}&nbsp;&gt;
                                </a>
                            )}
                            {!isIOSA && <p className="text-desc">{t('ios-tip')}</p>}
                        </div>
                        <div className="img-box">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1768982663753/12.png" alt={t`Use AR to fit PowerOcean in your house`} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
